<template>
  <div class="noData">
    <div class="content">
      <div class="img-wrap">
        <img :src="img" alt="" />
      </div>
      <div class="text-wrap">{{ text }}</div>
      <div class="btn" @click="handleClick">{{ btnText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "noData",
  props: {
    text: {
      type: String,
      default: "您还未添加银行卡～",
    },
    btnText: {
      type: String,
      default: "去添加",
    },
    img: {
      type: String,
      default: `require('@/assets/style/bank-noData.png')`,
    },
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    handleClick() {
     this.$emit("clickNoData");
    },
  },
};
</script>

<style scoped lang="scss">
.noData {
  height: calc(100vh - 56px);
  display: flex;
  justify-content: center;
}
.content {
  text-align: center;
}
.img-wrap {
  margin-top: 80px;
  img {
    width: 205px;
    height: 205px;
  }
}
.text-wrap {
  font-size: 14px;
  color: #333333;
  margin-top: -12px;
}
.btn {
  margin-top: 34px;
  width: 200px;
  height: 52px;
  line-height: 52px;
  background: #1d70f7;
  border-radius: 30px;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  font-weight: 500;
}
</style>
